function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1792",
  "data-name": "Group 1792",
  transform: "translate(-277.574 -53.006)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1790",
  "data-name": "Group 1790",
  transform: "translate(277.574 53.006)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1928",
  "data-name": "Path 1928",
  d: "M281.941,53.773h9.924c3.753-.059,6.2,1.425,6.2,5.442a5.566,5.566,0,0,1-4.772,5.588v.059c1.717.524,2.153,2.037,2.153,3.666,0,.932-.147,2.328-.147,3.608a7.342,7.342,0,0,0,.292,2.416h-4.453a6,6,0,0,1-.2-1.4c0-1.4.233-2.823.233-4.22,0-2.008-1.192-2.5-3-2.5H283.86l-1.717,8.12h-4.57Zm2.619,9.4h4.22c2.416-.03,4.714-.96,4.714-3.289,0-2.241-1.571-2.561-3.375-2.561h-4.337Z",
  transform: "translate(-277.574 -53.278)",
  fill: "#0f4dbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1929",
  "data-name": "Path 1929",
  d: "M314.55,53.774h15.86l-.785,3.842H318.332l-.932,4.452h10.448l-.756,3.552H316.644l-1.077,5.092h11.467l-.814,3.842H310.183Z",
  transform: "translate(-289.171 -53.279)",
  fill: "#0f4dbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1930",
  "data-name": "Path 1930",
  d: "M356.683,72.155h-.057a6.328,6.328,0,0,1-5.239,2.619c-5.821,0-9.226-3.346-9.226-9.2,0-6.723,4.337-12.572,11.35-12.572,4.862,0,8.819,2.27,8.819,7.363h-4.57c-.117-2.5-1.689-3.521-4.22-3.521-4.685,0-6.81,4.743-6.81,8.73,0,2.852,1.4,5.355,4.715,5.355,3.463,0,4.976-1.834,5.763-4.482h-4.8l.727-3.406h8.817L359.564,74.28h-2.881Z",
  transform: "translate(-300.543 -53.006)",
  fill: "#0f4dbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1931",
  "data-name": "Path 1931",
  d: "M378.954,53.774h15.862l-.787,3.842H382.737l-.93,4.452h10.448l-.757,3.552H381.05l-1.077,5.092h11.465l-.814,3.842H374.589Z",
  transform: "translate(-312.076 -53.279)",
  fill: "#0f4dbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1932",
  "data-name": "Path 1932",
  d: "M409.108,53.774h4.715l5.645,14.784h.058l2.97-14.784h4.19l-4.395,20.779h-4.569l-5.7-14.581h-.057l-2.969,14.581h-4.279Z",
  transform: "translate(-322.79 -53.279)",
  fill: "#0f4dbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1933",
  "data-name": "Path 1933",
  d: "M442.546,53.774h15.862l-.787,3.842H446.329l-.93,4.452h10.448l-.756,3.552H444.642l-1.077,5.092h11.466l-.815,3.842H438.181Z",
  transform: "translate(-334.692 -53.279)",
  fill: "#0f4dbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1934",
  "data-name": "Path 1934",
  d: "M472.671,53.773h9.924c3.753-.059,6.2,1.425,6.2,5.442a5.566,5.566,0,0,1-4.772,5.588v.059c1.717.524,2.153,2.037,2.153,3.666,0,.932-.147,2.328-.147,3.608a7.341,7.341,0,0,0,.292,2.416h-4.452a5.965,5.965,0,0,1-.2-1.4c0-1.4.233-2.823.233-4.22,0-2.008-1.193-2.5-3-2.5h-4.308l-1.717,8.12H468.3Zm2.619,9.4h4.22c2.416-.03,4.714-.96,4.714-3.289,0-2.241-1.571-2.561-3.375-2.561h-4.337Z",
  transform: "translate(-345.405 -53.278)",
  fill: "#0f4dbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1935",
  "data-name": "Path 1935",
  d: "M514.116,53.006c5.617,0,9.225,3.085,9.225,8.906,0,6.839-4.073,12.863-11.348,12.863-5.821,0-9.227-3.346-9.227-9.2C502.766,58.856,507.1,53.006,514.116,53.006Zm-2.065,17.927c4.482,0,6.722-4.773,6.722-8.7,0-2.911-1.281-5.384-4.626-5.384-4.686,0-6.811,4.743-6.811,8.73C507.335,68.43,508.732,70.933,512.051,70.933Z",
  transform: "translate(-357.661 -53.006)",
  fill: "#0f4dbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1936",
  "data-name": "Path 1936",
  d: "M540.448,53.774h4.714l5.647,14.784h.058l2.968-14.784h4.192l-4.395,20.779h-4.57l-5.7-14.581H543.3L540.33,74.553h-4.277Z",
  transform: "translate(-369.499 -53.279)",
  fill: "#0f4dbc"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1791",
  "data-name": "Group 1791",
  transform: "translate(472.434 53.006)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1937",
  "data-name": "Path 1937",
  d: "M585.106,53.886a2.892,2.892,0,0,0-2.121-.88,2.94,2.94,0,0,0-2.065.814,2.863,2.863,0,0,0-.936,2.187,3,3,0,1,0,5.123-2.121Zm-.374,3.889a2.456,2.456,0,0,1-3.5,0,2.491,2.491,0,0,1-.012-3.51,2.435,2.435,0,0,1,3.514,0,2.488,2.488,0,0,1,0,3.506Zm-.388-.289a.712.712,0,0,1-.007-.1v-.3a.9.9,0,0,0-.293-.746,1.119,1.119,0,0,0-.472-.193,1.085,1.085,0,0,0,.577-.224.726.726,0,0,0,.233-.605.837.837,0,0,0-.444-.794,1.606,1.606,0,0,0-.655-.171c-.047,0-.276,0-.686-.006l-.927,0v3.328h.872V56.5h.184l.191.012a.983.983,0,0,1,.3.052.405.405,0,0,1,.245.244,1.554,1.554,0,0,1,.055.407,2.47,2.47,0,0,0,.054.461h.831l-.031-.094A.519.519,0,0,1,584.343,57.486Zm-.988-1.707a.807.807,0,0,1-.477.123h-.338v-.966h.211a1.45,1.45,0,0,1,.506.07.381.381,0,0,1,.269.378A.45.45,0,0,1,583.355,55.779Z",
  transform: "translate(-579.983 -53.006)",
  fill: "#0f4dbc",
  fillRule: "evenodd"
})));

function SvgRegeneronLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.863,
    height: 21.768,
    viewBox: "0 0 200.863 21.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegeneronLogo);
export default __webpack_public_path__ + "static/media/regeneron_logo.e90d6c61.svg";
export { ForwardRef as ReactComponent };